<div class="text-center pt-2">
  <h5 class="text-success">Thank you for verifying your email address ({{ user.email }}).</h5>

  <div class="mt-4">
    <a routerLink="/"><strong>Click here to login</strong></a>
  </div>
</div>
